import createAlignmentPlugin from './draft-js-alignment-plugin';
export const alignmentPlugin = createAlignmentPlugin();
